// extracted by mini-css-extract-plugin
export var emailBlockLink = "_iu-0";